/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import InputCep from "../../../../components/InputCep";
import { Container, SectionTitle } from "./styles";
import FormWrapper from "../../../../components/Form";
import Input from "../../../../components/Input";
import Button from "../../../../components/Button";
import { IUser } from "../../../../entities/User";
import Badge from "../../../../components/Badge";
import UploadBox from "../../../../components/UploadBox";
import { isValidFileType } from "../../../../utils/functions.js";
import ErrorMessage from "../../../../components/ErrorMessage";
import Modal from "../../../../components/ModalAdmin";
import UploadTable from "../../../../components/UploadTable";

import api from "../../../../services/api";
import { AccountsContext as Context } from "../../../../context/AccountsContext";

import useToggle from "../../../../hooks/useToggle";
import useFileUpload from "../../../../hooks/useFileUpload";

interface ResidenceFormProps {
  user: IUser | undefined;
  setUser: any;
}

type FormData = {
  zip_code: string;
  street: string;
  number: string;
  complement: string;
  city: string;
  state: string;
  neighborhood: string;
  country: string;
};

const ResidenceForm: React.FC<ResidenceFormProps> = ({ user, setUser }) => {
  const {
    setDisableUploadResidenceProveDocuments,
    disableUploadPersonalDocuments,
    disableUploadResidenceProveDocuments,
  } = useContext(Context);
  const [generalError, setGeneralError] = useState<string>("");
  const [loading, setLoading] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useToggle(false);
  const [modalTitle, setModalTitle] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const { loadingStatus, uploadFile, uploadStatus } = useFileUpload();

  const errorFileTypeMessage =
    "Por favor, confira se seu arquivo é do tipo .jpeg, .jpg, .png, .pdf e ele deve possuir no máximo 10MB de tamanho.";

  const [documentErrorMsg, setDocumentErrorMsg] = useState("");
  const [addressErrorMsg, setAddressErrorMsg] = useState("");

  const userModal = (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={setIsModalOpen}
      closeModal={setIsModalOpen}
      headerLabel={modalTitle}
    >
      <UploadTable endpoint={endpoint} />
    </Modal>
  );

  const tooltipUserAddress = (
    <ReactTooltip
      effect="solid"
      place="top"
      id="tooltip-address"
      aria-haspopup="true"
    >
      <p style={{ color: "#fff", maxWidth: "300px", textAlign: "center" }}>
        Por favor, verifique se os dados residenciais estão devidamente
        preenchidos nos campos acima
      </p>
      <p style={{ color: "#fff", maxWidth: "300px", textAlign: "center" }}>
        O campo de upload só será liberado após o preenchimento dos seus dados
        residenciais.
      </p>
    </ReactTooltip>
  );

  const uploadUserDocuments = useCallback(
    (file, type) => {
      if (isValidFileType(file)) {
        uploadFile(file, type, "profile/upload-documents");
      } else {
        type === "USUARIO_DOCUMENTO" &&
          setDocumentErrorMsg(errorFileTypeMessage);
        type === "USUARIO_RESIDENCIA" &&
          setAddressErrorMsg(errorFileTypeMessage);
      }
    },
    [uploadFile]
  );

  const { register, setValue, handleSubmit, errors, reset } = useForm<FormData>(
    {
      defaultValues: {
        ...user,
      },
    }
  );

  useEffect(() => {
    reset({
      ...user,
    });

    if (
      user?.zip_code === null ||
      user?.zip_code === "" ||
      user?.street === "" ||
      user?.street === null ||
      user?.neighborhood === "" ||
      user?.neighborhood === null ||
      user?.city === "" ||
      user?.city === null ||
      user?.state === "" ||
      user?.state === null
    ) {
      setDisableUploadResidenceProveDocuments(true);
    } else {
      setDisableUploadResidenceProveDocuments(false);
    }
  }, [reset, setDisableUploadResidenceProveDocuments, user]);

  const onSubmit = async (data: FormData) => {
    try {
      const response = await api.put("/profile/address", {
        ...data,
        country: "brazil",
      });
      toast.success("Endereço atualizado com sucesso!");
      const userRes: IUser = response.data.data;
      setUser(userRes);
      setDisableUploadResidenceProveDocuments(false);
    } catch (error) {}
  };

  const handleUserModal = useCallback(
    (title, endpointRoute) => {
      setModalTitle(title);
      setEndpoint(endpointRoute);
      setIsModalOpen();
    },
    [setIsModalOpen]
  );

  return (
    <Container cardTitle="Dados residenciais" loading={loading}>
      <span>{generalError}</span>
      <FormWrapper onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <InputCep
            label="CEP"
            id="zip_code"
            name="zip_code"
            className="col-xs-12 col-sm-3"
            type="text"
            mask="99999-999"
            value={user?.zip_code}
            setValue={setValue}
            setLoading={setLoading}
            disabled={!user?.can_edit_address_information}
            register={register({
              required: { value: true, message: "Campo obrigatório" },
            })}
            errorMessage={errors.zip_code?.message}
          />

          <Input
            label="Rua"
            id="street"
            name="street"
            mask=""
            type="text"
            disabled={!user?.can_edit_address_information}
            className="col-xs-12 col-sm-7"
            register={register({
              required: { value: true, message: "Campo obrigatório" },
              minLength: {
                value: 3,
                message: "Obrigatorio pelo menos 3 caracteres",
              },
            })}
            errorMessage={errors.street?.message}
          />
          <Input
            label="Número"
            id="number"
            name="number"
            disabled={!user?.can_edit_address_information}
            className="col-xs-6 col-sm-2"
            register={register}
            errorMessage={errors.number?.message}
          />
          <Input
            label="Complemento"
            id="complement"
            name="complement"
            disabled={!user?.can_edit_address_information}
            className="col-xs-5 col-sm-5"
            register={register}
            errorMessage={errors.complement?.message}
          />

          <Input
            label="Bairro"
            id="neighborhood"
            name="neighborhood"
            disabled={!user?.can_edit_address_information}
            className="col-xs-7 col-sm-7"
            register={register({
              required: { value: true, message: "Campo obrigatório" },
            })}
            errorMessage={errors.neighborhood?.message}
          />
          <Input
            label="Cidade"
            id="city"
            name="city"
            disabled={!user?.can_edit_address_information}
            className="col-xs-5 col-sm-5"
            register={register({
              required: { value: true, message: "Campo obrigatório" },
            })}
            errorMessage={errors.city?.message}
          />
          <Input
            label="Estado"
            id="state"
            name="state"
            disabled={!user?.can_edit_address_information}
            className="col-xs-7 col-sm-2"
            register={register({
              required: { value: true, message: "Campo obrigatório" },
            })}
            errorMessage={errors.state?.message}
          />
        </div>
        {user?.can_edit_address_information && (
          <div
            className="row"
            style={{ margin: "10px 0 55px 0", justifyContent: "flex-end" }}
          >
            <Button primaryPill>Salvar</Button>
          </div>
        )}
      </FormWrapper>

      {userModal}
      {user?.is_account_owner && (
        <FormWrapper>
          <div className="col col-md-12">
            <div className="section-title-badge row">
              <div className="col col-sm-9 d-flex">
                <SectionTitle>Comprovante de residência</SectionTitle>


                <Button
                  type="button"
                  className="view-uploads-button"
                  onClick={() =>
                    handleUserModal(
                      "Comprovante de residência",
                      "/profile/get-documents?document_type=USUARIO_RESIDENCIA"
                    )
                  }
                >
                  Ver uploads
                </Button>
              </div>

              <div className="col  badge">
                <Badge
                  status={user?.address_document_translate}
                  className="badge"
                />
              </div>
            </div>

            {user?.address_document_translate !== "Aprovado" && (
              <>
                <p style={{ marginBottom: "15px" }}>
                  O Comprovante de endereço deve ser no nome do usuário e estar
                  dentro do prazo de 90 dias de vencimento. São aceitos como
                  comprovantes de residência as vias digitais ou fotos das
                  contas de:
                </p>
                <ul style={{ marginLeft: "30px" }}>
                  <div className="row" style={{ margin: "0" }}>
                    <li className="col-xs-12 col-md-7">Água</li>
                    <li className="col-xs-12 col-md-5">Luz</li>
                    <li className="col-xs-12 col-md-7">Internet</li>
                    <li className="col-xs-12 col-md-5">
                      Telefone fixo ou móvel
                    </li>
                    <li className="col-xs-12 col-md-5">Gás encanado</li>
                  </div>
                </ul>
                <p style={{ marginTop: "15px", fontSize: "11px" }}>
                  OBS: Caso o comprovante esteja em nome de terceiros, é
                  necessário enviar uma declaração de residência assinada pelo
                  titular da conta e uma foto do mesmo.
                </p>
                <div data-for="tooltip" data-tip>
                  <UploadBox
                    id="uploadResidenceProve"
                    className="uploadbox"
                    wholeFile={(file: File) =>
                      uploadUserDocuments(file, "USUARIO_RESIDENCIA")
                    }
                    disabled={disableUploadResidenceProveDocuments}
                    uploadStatus={uploadStatus}
                  />
                </div>
                {addressErrorMsg && (
                  <ErrorMessage>{addressErrorMsg}</ErrorMessage>
                )}
                {disableUploadResidenceProveDocuments && tooltipUserAddress}
              </>
            )}
          </div>
        </FormWrapper>
      )}
    </Container>
  );
};

export default ResidenceForm;
